var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { doWhenP } from '../utils';
import { updateRequest, getRequestId } from '../dataLayer';
import { getCacheItem, setCacheItem } from '../cache';
import { cookie } from '../web';
const CACHED_KEY = 'ga_client_id';
/** @returns {string|null} */
export function getCachedClId() {
    let clientId = null;
    const cache = getCacheItem(CACHED_KEY);
    if (typeof cache === 'string') {
        clientId = cache;
    }
    else if (typeof cache === 'object' && cache.client_id) {
        clientId = cache.client_id;
    }
    return clientId;
}
/** @returns {string|null} */
export function getClientId() {
    let clientId = null;
    const ga = cookie('_ga');
    const [id] = ga.match(/\d+\.\d+$/) || [];
    if (id) {
        clientId = id;
    }
    else if (ga && ga.length) {
        clientId = ga;
    }
    return clientId;
}
/** @returns {void} */
function sendClientId() {
    const requestId = getRequestId();
    const clientId = getClientId();
    const cachedData = getCacheItem(CACHED_KEY);
    const data = {
        request_id: requestId,
        client_id: clientId,
    };
    const sameReqId = typeof cachedData === 'object' && cachedData.request_id === requestId;
    const sameClientId = typeof cachedData === 'object' && cachedData.client_id === clientId;
    if (sameReqId && sameClientId)
        return;
    updateRequest(requestId, { google_client_id: data }).then(() => {
        setCacheItem(CACHED_KEY, data);
    });
}
/** @returns {void} */
function handlePredicate() {
    return getClientId() && getRequestId();
}
/**
 * @param {number} [expiration=10000]
 * @param {number} [interval=500]
 * @returns {Promise<any>}
 */
export function run() {
    return __awaiter(this, arguments, void 0, function* (expiration = 10000) {
        return doWhenP(handlePredicate, expiration, false)
            .then(() => sendClientId())
            .catch(e => {
            console.log('error sending ga client ID: ', e);
            return e;
        });
    });
}
//# sourceMappingURL=GoogleClientId.js.map